/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolTramIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-tram"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3.65 17.75L3.65 8Q3.65 5.4 5.75 4.58Q7.85 3.75 10.9 3.67L11.65 2.15L7.63 2.15Q7.28 2.15 7.04 1.91Q6.8 1.68 6.8 1.32Q6.8 0.97 7.04 0.74Q7.28 0.5 7.63 0.5L16.38 0.5Q16.73 0.5 16.96 0.74Q17.2 0.97 17.2 1.32Q17.2 1.68 16.96 1.91Q16.73 2.15 16.38 2.15L13.9 2.15L13.1 3.67Q16.2 3.75 18.27 4.55Q20.35 5.35 20.35 8L20.35 17.75Q20.35 19.3 19.27 20.38Q18.2 21.45 16.65 21.45L17.1 21.9Q17.57 22.38 17.32 22.99Q17.07 23.6 16.4 23.6Q16.2 23.6 16 23.51Q15.8 23.43 15.68 23.3L13.82 21.45L10.18 21.45L8.32 23.3Q8.2 23.43 8 23.51Q7.8 23.6 7.6 23.6Q6.92 23.6 6.67 22.99Q6.42 22.38 6.9 21.9L7.35 21.45Q5.8 21.45 4.72 20.38Q3.65 19.3 3.65 17.75ZM11.97 18.3Q11.97 18.3 12.31 18.3Q12.65 18.3 13.13 17.82Q13.6 17.35 13.6 16.68Q13.6 16 13.13 15.53Q12.65 15.05 11.97 15.05Q11.3 15.05 10.82 15.53Q10.35 16 10.35 16.68Q10.35 17.35 10.82 17.82Q11.3 18.3 11.97 18.3ZM5.9 11.85L18.1 11.85L18.1 9.1L5.9 9.1Z" fill={color} />
    </svg>
  );
}
